import React from "react";
import { connect } from "react-redux";

//store
import * as actions from "../../store/actions/actionIndex";
import { notify } from "../../helpers/utility";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Button, Dialog, FormControl, Select, MenuItem, InputLabel, TextField, Grid, Typography, IconButton, DialogContent as MuiDialogContent, DialogActions as MuiDialogActions, DialogTitle as MuiDialogTitle } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";

const styles = (theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: "absolute",
		insetInlineEnd: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
});
const useStyles = makeStyles((theme) => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
}));



const DialogTitle = withStyles(styles)((props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

const DialogContent = withStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(1),
	},
}))(MuiDialogActions);

function CustomerLeadCRM(props) {
	const { leadId } = props;
	const [open, setOpen] = React.useState(true);

	const handleClose = () => {
		
		setOpen(false);
		props.unSetLead();
	};

	/* Gender Select Code*/
	const classes = useStyles();

	let leadFields = Array.from(props.leadFields ? props.leadFields : props.crmFields);

	let currState = {};
	if (leadFields.length) {
		leadFields.map((item, index) => {
			if (item.group.length) {
				item.group.map((arrItem) => {
					currState[arrItem.name] = typeof props.leadValues[arrItem.name] !== "undefined" ? props.leadValues[arrItem.name] : arrItem.value;
					return true;
				});
			}
			return true;
		});
	}

	const [crmValues, setValues] = React.useState(currState);
	const [state, setState] = React.useState({});

	const handleLeadChange = (event) => {
		//console.log("handleLeadChange", event.target.name, event.target.value);
		event.persist();
		setValues({
			...crmValues,
			[event.target.name]: event.target.value,
		});
		setState({
			...state,
			[event.target.name]: event.target.value,
		});
	};

	const handleLeadUpdate = () => {
		console.log("hii")
		if (Object.keys(state).length > 0) {
			props.onCustomerDetails(props.agentId, props.campaignId, props.leadId, state);
			handleClose()
		} else {
			notify("CRM Error: No data to update", "crm-error");
		}
	};

	// if (!leadId && !props.loading && props.error === null) {
	// 	handleClose();
	// }

	return (
		<div>
			<Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
				<DialogTitle id="customized-dialog-title" onClose={handleClose}>
					Customer Information
				</DialogTitle>
				<DialogContent className = "crm-lead" dividers>
					<form  noValidate autoComplete="off">
						{leadId && leadFields.length
							? leadFields.map((item, index) => {
						  if (item.group.length) {
							return (
											<div key={index}>
												<Typography className ="list-label" style={{ marginBottom: "5px", marginTop: "5px" }}>{item.groupLabel}</Typography>
												<Grid container spacing={3} style={{ marginBottom: "5px", marginTop: "5px", padding: "0 20px" }}>
													{item.group.length &&
														item.group.map((arrItem, index2) => {
															if (arrItem.type === "select") {
																return (
																	<Grid key={index2} item xs={12} md={4}>
																		<FormControl variant="outlined" className={classes.formControl} size="small" style={{ margin: "0", width: "100%" }}>
													<InputLabel id="demo-simple-select-outlined-label">{arrItem.label} </InputLabel>
													<Select
                                              labelId="demo-simple-select-outlined-label"
                                              id="demo-simple-select-outlined"
                                             name={arrItem.name}
                                            value={crmValues[arrItem.name]}
                                            onChange={handleLeadChange}
                                            label={arrItem.label}
                                             disabled={arrItem.isWritable === false ? true : false}
                                            >
                                    {Object.entries(arrItem.options).map(([key, value]) => (
                                    <MenuItem key={key} value={value}>
                                         {value}
                                     </MenuItem>
                                       ))}
                                     </Select>

																		</FormControl>
																	</Grid>
																);
															}
															if (arrItem.type === "checkbox") {
																return (
																	<Grid key={index2} item xs={12} md={4}>
																		<TextField id="outlined-basic" label={arrItem.label} name={arrItem.name} variant="outlined" size="small" onChange={(event) => handleLeadChange(event)} value={crmValues[arrItem.name]}   disabled ={arrItem.isWritable === false ? true : false} />
																	
																	</Grid>
																);
															}
															return (
																<Grid key={index2} item xs={12} md={4}>
																	<TextField id="outlined-basic" label={arrItem.label} name={arrItem.name} variant="outlined" size="small" onChange={(event) => handleLeadChange(event)} value={
                                            arrItem.isWritable === false 
                                              ? (crmValues[arrItem.name] !== "" 
                                                  ? crmValues[arrItem.name]
                                                  : "N/A") 
                                              : crmValues[arrItem.name]
                                          } 
																	  disabled ={arrItem.isWritable === false ? true : false}
																	  />
																</Grid>
															);
														})}
												</Grid>
											</div>
										);
									}
									return null;
							  })
							: null}
					</form>
				</DialogContent>
				<DialogActions>
					<Button className="update-btn" autoFocus onClick={handleLeadUpdate} color="primary">
						Update
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		error: state.customerDetails.error,
		loading: state.customerDetails.loading,
		leadFields: state.customerDetails.leadFields,
		crmFields: state.customerDetails.crmFields,
		leadValues: state.customerDetails.leadValues,
		agentId: state.agentData.agentId,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onGetCustomerDetails: (agentId, leadId, leadType) => dispatch(actions.getCustomerDetails(agentId, leadId, leadType)),
		onCustomerDetails: (agentId, campaignId, leadId, setValues) => dispatch(actions.customerDetails(agentId, campaignId, leadId, setValues)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerLeadCRM);
